import {Component, OnInit} from '@angular/core';
// import {$state} from "app/ajs-upgraded-providers";

@Component({
	standalone: true,
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss']
})
export class StockComponent implements OnInit {

    // constructor(@Inject($state)private state: any) {
    //     this.state.go("app.stock");
    // }

  ngOnInit(): void {
  }

}
